import { FolderPlus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { t } from '@/utils/i18n';

interface NewFolderCardProps {
  onClick: () => void;
  className?: string;
}

export function NewFolderCard({ onClick, className }: NewFolderCardProps) {
  return (
    <button
      data-tour="folder-new"
      onClick={onClick}
      className={cn(
        'w-full',
        'bg-transparent rounded-[12px]',
        'border border-dashed border-[#CDD5E0] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#BCD0FA]',
        'px-3.5 py-2.5',
        'flex items-center justify-center',
        'cursor-pointer',
        'transition-all duration-[180ms] ease-out',
        'h-[72px] min-h-[72px] hover:bg-[#F8FAFC] hover:border-[#B8C8E8]',
        className
      )}
    >
      <div className="flex items-center gap-2.5">
        <FolderPlus className="h-[18px] w-[18px] text-[#3F6FE5]" strokeWidth={1.8} />
        <span className="text-[14px] font-medium text-[#344054]">{t('newFolderLabel')}</span>
      </div>
    </button>
  );
}
